var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 26.458 26.458",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "light-circle-fill",
    gradientTransform: "matrix(.52917 0 0 .52917 -54.067 170.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -270.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.486 283.34-17.47 10.086v-10.086-10.086l8.735 5.0431z",
    fill: "url(#light-circle-fill)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.788a5e8d1c147e023fef5813aa5ce74d.svg";